import styled from "styled-components";

export const Card = styled.div<{
  $width?: string | undefined;
  $backgroundColor?: string | undefined;
  $textColor?: string | undefined;
}>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.regular};
  padding: ${({ theme }) => theme.padding.regular};
  border-radius: ${({ theme }) => theme.borderRadius.regular};
  background: ${({ $backgroundColor, theme }) =>
    $backgroundColor ?? theme.colors.grey};
  color: ${({ $textColor, theme }) => $textColor ?? theme.colors.text};
  width: ${({ $width }) => $width ?? "auto"};

  @media (min-width: 1025px) and (max-width: 1519px) and (max-height: 768px) {
    gap: ${({ theme }) => theme.spacing.small};
    padding: 12px;
  }

  @media (max-width: 520px) {
    min-width: 0;
  }

  @media (min-width: 2500px) {
    padding: ${({ theme }) => theme.padding.medium};
    border-radius: ${({ theme }) => theme.borderRadius.medium};
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (min-width: 3400px) {
    padding: ${({ theme }) => theme.padding.large};
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
  @media (min-width: 3800px) {
    gap: 82px;
  }
  @media (min-width: 4500px) {
    padding: 52px;
  }
`;
export const Number = styled.span`
  font-size: 64px;
  font-weight: 600;
  line-height: 1;

  @media (min-width: 1025px) and (max-width: 1519px) and (max-height: 768px) {
    font-size: ${({ theme }) => theme.typography.h1.fontSize};
  }

  @media (max-width: 1024px) {
    font-size: ${({ theme }) => theme.typography.h1.fontSize};
  }

  @media (min-width: 2500px) {
    font-size: 4.5rem;
  }
  @media (min-width: 2500px) and (max-height: 1080px) {
    font-size: 4rem;
  }
  @media (min-width: 3400px) {
    font-size: 5.5rem;
  }
  @media (min-width: 3800px) {
    font-size: 6.5rem;
  }
  @media (min-width: 4500px) {
    font-size: 7rem;
  }
  @media (min-width: 5000px) {
    font-size: 8.5rem;
  }
`;

export const Subtitle = styled.span`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: 600;
  white-space: pre-line;

  @media (min-width: 1025px) and (max-width: 1519px) and (max-height: 768px) {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};
  }

  @media (max-width: 1024px) {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};
  }

  @media (min-width: 2500px) {
    font-size: 1.75rem;
  }
  @media (min-width: 2500px) and (max-height: 1080px) {
    font-size: 1.5rem;
  }
  @media (min-width: 3000px) {
    font-size: 2rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.25rem;
  }
  @media (min-width: 3800px) {
    font-size: 2.75rem;
  }
  @media (min-width: 4500px) {
    font-size: 3.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 3.75rem;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: end;

  @media (max-width: 520px) {
    display: flex;
    margin-top: ${({ theme }) => theme.spacing.xsmall};
  }
`;

export const Text = styled.span`
  font-size: ${({ theme }) => theme.typography.medium.fontSize};

  @media (min-width: 1025px) and (max-width: 1519px) and (max-height: 768px) {
    font-size: ${({ theme }) => theme.typography.regular.fontSize};
    line-height: 1.35;
  }

  @media (max-width: 1024px) {
    font-size: ${({ theme }) => theme.typography.regular.fontSize};
  }

  @media (min-width: 2500px) {
    font-size: 1.5rem;
  }
  @media (min-width: 2500px) and (max-height: 1080px) {
    font-size: 1.4rem;
  }
  @media (min-width: 3400px) {
    font-size: 2rem;
  }
  @media (min-width: 3800px) {
    font-size: 2.5rem;
  }
  @media (min-width: 4500px) {
    font-size: 3rem;
  }
  @media (min-width: 5000px) {
    font-size: 3.25rem;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  @media (min-width: 2500px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const Rating = styled.div`
  display: flex;

  @media (min-width: 2500px) {
    font-size: 1.75rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.25rem;
  }
  @media (min-width: 3800px) {
    font-size: 2.75rem;
  }
  @media (min-width: 4500px) {
    font-size: 3.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 3.75rem;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;
